import { render } from "./ReservationSuccess.vue?vue&type=template&id=38dd859d"
import script from "./ReservationSuccess.vue?vue&type=script&lang=js"
export * from "./ReservationSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__